import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { useVisualMediaPlacement } from 'hooks/timeline/useVisualMediaPlacement'
import { TextStyles } from './components/text-styles'
import { ITextStyle } from './components/text-styles/mock-text-styles'
import * as Styled from './styled'
import { generateTextMediaItem } from './helpers'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { editorThunks } from 'store/features/editor/thunks'

const TEXT_CLIP_DURATION = 5

const TextContent: React.FC = () => {
  const getPlacement = useVisualMediaPlacement()
  const { height: canvasHeight } = useSelector(
    projectDataSelectors.defaultDimensions
  )

  const handleStyleSelect = useCallback(
    (style: ITextStyle) => {
      const placement = getPlacement(TEXT_CLIP_DURATION)
      const newItem = generateTextMediaItem(
        style,
        placement.startTime,
        placement.zIndex,
        canvasHeight
      )
      dispatch(projectDataThunks.addMediaItems({ value: [newItem] }))
      dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
    },
    [getPlacement, canvasHeight]
  )

  return (
    <Styled.Wrapper>
      <Styled.Title>{translate(T.ADD_TEXT_LABEL)}</Styled.Title>
      <TextStyles onSelect={handleStyleSelect} />
    </Styled.Wrapper>
  )
}

export default TextContent
